import { ErrorContainer } from "./ErrorContainer";
import { useNotifications } from "./NotificationsContext";
import { ToastStack } from "./ToastStack";

export const Notifications = () => {
  const { toasts, errors, removeToast, removeError } = useNotifications();

  return (
    <>
      <ToastStack notifications={toasts} removeToast={removeToast} />

      <ErrorContainer notifications={errors} removeError={removeError} />
    </>
  );
};
